import { useEffect, useState } from "react";
import List from "./List";
import WorkInProgressPilesDrawer from "./Drawer/PliesDrawer";
import { Grid, Drawer } from "@material-ui/core";
import { Text, SVG } from "sunrise-ui";
import "./Dashboard.scss";
import { useSelector, useDispatch } from "react-redux";
import {
  getWIPOpersAndEngs,
  getWorkInProgressPilesData,
  getStepsDropList,
  getOperatorsInShift,
} from "../../redux/reducers/dashboardReducers";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import { Pie } from "react-chartjs-2";
import { AppDispatch } from "../../redux/store";
import { timeFormatter } from "../../utilities/timeHandler";
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
);

// Will remove later
// const arr: any[] = [1, 2, 3, 4, 5, 6];

const WorkInProgressPiles = (props: any) => {
  const { engsInShifData } = props;
  const dispatch = useDispatch<AppDispatch>();
  const [drawerData, setDrawerData] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [stepsData, setStepsData] = useState([
    { number: 1, count: 0.05 },
    { number: 2, count: 0.05 },
    { number: 3, count: 0.05 },
    { number: 4, count: 0.05 },
    { number: 5, count: 0.05 },
    { number: 6, count: 0.05 },
    { number: 7, count: 0.05 },
    { number: 8, count: 0.05 },
  ]);
  const [dataToDownload, setDataToDownload] = useState([]);

  const WIPPiles = useSelector((state: any) => state.DASHBOARD.WIPPiles);
  const stepsWithCount = useSelector(
    (state: any) => state.DASHBOARD.stepsWithCount
  );
  const totalDelayHours = useSelector(
    (state: any) => state.DASHBOARD.totalDelayHours
  );
  const workInprogressData = useSelector(
    (state: any) => state.DASHBOARD.workInProgressPilesData
  );
  const allProject = useSelector((state: any) => state.PROJECT.allProjectData);

  const operatorsInShift = useSelector(
    (state: any) => state.DASHBOARD.operatorsInShift
  );

  //--------pie chart data----------
  const pieChartData = {
    labels: stepsWithCount.map((c: any) => c.name),
    datasets: [
      {
        label: "piles steps deyails",
        data: stepsWithCount.map((c: any) => c.count),
        backgroundColor: [
          "#5F67E0",
          "#E8A838",
          "#4dd0e1",
          "#607d8b",
          "#94fa60",
          "#bbdefb",
          "#FCE100",
          "#aa2388",
        ],
      },
    ],
  };
  useEffect(()=>{
    const project_id: any = allProject?.find(
      (val: any) => val?.projectName === props?.projectName
    )?._id;
      if(project_id){
        dispatch(
          getOperatorsInShift({
            endPoint: `general/get-operator-in-shift?projectId=${project_id}`,
          })
        );
      }
  },[allProject, dispatch, props?.projectName])

  useEffect(() => {
    const list = stepsData?.map((val: any) => {
      const item = workInprogressData?.steps?.find(
        (val2: any) => val2?.number === val.number
      );
      if (item) {
        if (val?.count < item.count) {
          return { number: item.number, count: item.count };
        }
      }
      return val;
    });
    setStepsData(list);
    // eslint-disable-next-line
  }, [workInprogressData]);

  useEffect(() => {
    if (Array.isArray(allProject)) {
      const project_id: any = allProject?.find(
        (val: any) => val?.projectName === props?.projectName
      )?._id;
      if (project_id) {
        dispatch(
          getWorkInProgressPilesData({
            endPoint: `piles/overview?status=IN_PROGRESS&project=${project_id}`,
          })
        );
        dispatch(
          getWIPOpersAndEngs({
            endPoint: `piles/manpower?pileStatus=IN_PROGRESS&project=${project_id}`,
          })
        );
      }
    }
    // eslint-disable-next-line
  }, [props.projectName]);

  const openDrawer = (data: any) => {
    setDrawerData(data);
    setDrawerOpen(true);
  };
  useEffect(()=>{
    let downloadData = WIPPiles?.map((ele:any)=>{
      return {
        'Pile Id': ele.pileId,
        'Step Number & Name':ele.stepNameNumber,
        'Machine Used':ele.machineUsed,
        'Last Worked by Engineer':ele.lastWorkedBy,
        'Step Work Started On':ele.startedOn,
      }
    })
    setDataToDownload(downloadData)
  },[WIPPiles]);

  const fields = [
    {
      header: "Pile Id",
      value: "pileId",
      search: true,
      action: function (obj: any) {
        return (
          <Text
            type="link"
            fonts="normal"
            fontSize={14}
            className="mb0 mt0 fw500 pointer"
            onTextClick={() => {
              dispatch(
                getStepsDropList({
                  endPoint: `piles/steps-filter?pileId=${obj?.id}`,
                })
              ).then(() => openDrawer(obj));
            }}
          >
            {obj.pileId}
          </Text>
        );
      },
    },
    {
      header: "Step Number & Name",
      search: true,
      value: "stepNameNumber",
    },
    { header: "Machine Used", value: "machineUsed", search: true },
    {
      header: "Last Worked by Engineer",
      value: "lastWorkedBy",
      search: true,
    },
    {
      header: "Step Work Started On",
      value: "startedOn",
      search: true,
    },
  ];

  return (
    <Grid className="bg--white box--shadow p1 mt1">
      <Grid container>
        <Grid item xs={4}>
          <Text fontSize={16} type="normal" fonts="normal" className="mb1 mt0">
            <span className="fw500">
              Pile Filling Overview For {props.projectName} Project
            </span>
          </Text>
          <Grid className="bg--white box--shadow p mr-1">
            <Text
              fontSize={16}
              type="normal"
              fonts="normal"
              className="mb0 mt0 fw500"
            >
              Total Work In Progress Piles ({WIPPiles?.length})
            </Text>
            <Pie data={pieChartData} />
          </Grid>
        </Grid>
        <Grid item xs={8}>
          <Grid className="p mt2 d-flex sb">
            <Grid className="operators_in_shift">
              <Text
                fontSize={16}
                type="normal"
                fonts="normal"
                className="mb0 mt0 fw500"
              >
                Overview Details
              </Text>
              <Grid className="box--shadow p mr-1 mt_low_space">
                <Text
                  fontSize={16}
                  type="normal"
                  fonts="normal"
                  className="mb0 mt0 fw500"
                >
                  Overall WIP Pile Delay
                </Text>
                <div className="flex_between mt_low_space pr">
                  <Grid className="total_box flex_start">
                    <span>
                      <SVG type="overallDelay" />
                    </span>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb0 mt_vlow_space fw400"
                    >
                      <span style={{ marginLeft: 10 }}> Delay (Hrs) </span>
                    </Text>
                  </Grid>
                  <Grid className="fw500 mt_vlow_space">
                    {totalDelayHours < 10
                      ? `0${totalDelayHours.toFixed(2)}`
                      : totalDelayHours.toFixed(2)}
                  </Grid>
                </div>
              </Grid>

              <Grid className="box--shadow p1 mt1 mr-1">
                <Text
                  fontSize={16}
                  type="normal"
                  fonts="normal"
                  className="mb0 mt0 fw500"
                >
                  Operators In Shift ({operatorsInShift.length>0?operatorsInShift.length:0})
                </Text>

                <div className="operator_container">
                  {operatorsInShift?.map((val: any) => (
                    <Grid className="total_box d-flex mt_low_space v-center">
                      <Grid className="icon_containr">
                        <span>
                          <SVG type="operator" />
                        </span>
                      </Grid>
                      <Text
                        type="normal"
                        fonts="normal"
                        fontSize={16}
                        className="mb0 mt0 fw400"
                      >
                        <span style={{ marginLeft: 8 }}> {val.name?val.name:""} </span>
                      </Text>
                    </Grid>
                  ))}
                </div>
              </Grid>
            </Grid>
            <Grid className="available_operator">
              <Grid className="box--shadow p1">
                <Text
                  fontSize={16}
                  type="normal"
                  fonts="normal"
                  className="mb0 mt0 fw500 flex_between pr-1"
                >
                  <span>
                    Available Engineers In Current Shift (
                    {engsInShifData ? engsInShifData.length : 0})
                  </span>
                  <span>Current Pile</span>
                </Text>
                <div className="available_operator_container">
                  {engsInShifData?.map((val: any, index: number) => (
                    <Grid className="flexbox-between" key={index}>
                      <Grid className="total_box d-flex mt_low_space">
                        <Grid className="pt_low_space">
                          <span>
                            <SVG type="engineer" />
                          </span>
                        </Grid>
                        <Text
                          type="normal"
                          fonts="normal"
                          fontSize={16}
                          className="mb0 mt0 fw400"
                        >
                          <span
                            style={{ marginLeft: 8 }}
                            className="capitalize"
                          >
                            {" "}
                            {val?.engineerDetails?.name}{" "}
                          </span>
                          <Text
                            type="normal"
                            fonts="normal"
                            fontSize={16}
                            className="mb0 mt0 fw300"
                          >
                            <span style={{ marginLeft: 8 }}>
                              Logged in at{" "}
                              {timeFormatter(
                                new Date(val?.loginTime)
                              ).toLocaleUpperCase()}
                            </span>
                          </Text>
                        </Text>
                      </Grid>
                      <Grid className="pt_low_space margin pile-id">
                        <Text
                          type="link"
                          fonts="normal"
                          fontSize={14}
                          className="mb0 mt0 fw500 pr"
                          onTextClick={() => {
                            dispatch(
                              getStepsDropList({
                                endPoint: `piles/steps-filter?pileId=${val?.pileDetails?.id}`,
                              })
                            ).then(() => openDrawer(val?.pileDetails));
                          }}
                        >
                          {val?.pileDetails?.pileId}
                        </Text>
                      </Grid>
                    </Grid>
                  ))}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className="mt0 p">
        <Grid item xs={4}></Grid>
        <Grid item xs={8}></Grid>
      </Grid>
      <Grid container>
        <List
          listData={WIPPiles ? WIPPiles : []}
          fields={fields}
          dataToDownLoad={dataToDownload}
          title={`Work In Progress Pile Details For ${props.projectName} Project`}
          project={props.projectName}
          sizeType="small"
          nodataText="No Piles Are Available For Work In Progress"
        />
      </Grid>
      {drawerData && (
        <Drawer
          anchor={"right"}
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <WorkInProgressPilesDrawer
            setDrawerOpen={setDrawerOpen}
            forPage="workinprogress"
            data={drawerData}
          />
        </Drawer>
      )}
    </Grid>
  );
};

export default WorkInProgressPiles;
